import { render, staticRenderFns } from "./location_customer.vue?vue&type=template&id=d8e57bc6&scoped=true&"
import script from "./location_customer.vue?vue&type=script&lang=js&"
export * from "./location_customer.vue?vue&type=script&lang=js&"
import style0 from "./location_customer.vue?vue&type=style&index=0&id=d8e57bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e57bc6",
  null
  
)

export default component.exports